import { COUNTRIES_FILTER_DATA } from "@/components/shared/constants/general.const";
import { splitCorridorCountryList } from "@shared/ecosystemHeadQuestionnaire";

export const ECOSYSTEM_HEAD_TARGET_COUNTRY_OPTIONS = COUNTRIES_FILTER_DATA.flatMap((group) =>
  group.items.map((item) => item.value),
);

function dedupeCountryNames(names: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of names) {
    const name = raw.trim();
    if (!name) continue;
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(name);
  }
  return out;
}

export function normalizeTargetCountryList(
  countries: string[] | string | null | undefined,
): string[] {
  if (Array.isArray(countries)) {
    return dedupeCountryNames(countries);
  }
  return splitCorridorCountryList(countries);
}

export function areAllTargetCountriesSelected(
  countries: string[] | string | null | undefined,
  options: string[] = ECOSYSTEM_HEAD_TARGET_COUNTRY_OPTIONS,
): boolean {
  if (options.length === 0) return false;
  const selected = normalizeTargetCountryList(countries);
  if (selected.length < options.length) return false;

  const selectedSet = new Set(selected.map((country) => country.toLowerCase()));
  return options.every((country) => selectedSet.has(country.toLowerCase()));
}

/** Compact label for admin tables, headers, and other read-only UI. */
export function formatTargetCountriesSummary(
  countries: string[] | string | null | undefined,
  opts?: { maxVisible?: number; options?: string[] },
): string {
  const list = normalizeTargetCountryList(countries);
  if (list.length === 0) return "";

  const options = opts?.options ?? ECOSYSTEM_HEAD_TARGET_COUNTRY_OPTIONS;
  if (areAllTargetCountriesSelected(list, options)) {
    return "All countries";
  }

  const maxVisible = opts?.maxVisible ?? 3;
  if (list.length <= maxVisible) return list.join(", ");
  return `${list.slice(0, maxVisible).join(", ")} +${list.length - maxVisible} more`;
}
